// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__iS5+B"};